import { render } from "./AppPlanprogrami.vue?vue&type=template&id=58d3f79c"
const script = {}

import "./AppPlanprogrami.vue?vue&type=style&index=0&id=58d3f79c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__